exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@keyframes rotation-data-v-4bed9f4c{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}.loading[data-v-4bed9f4c]{position:fixed;z-index:9999;top:0;left:0;width:100%;height:100%;background:#fff;opacity:.5}.loading__circle[data-v-4bed9f4c]{position:absolute;top:50%;left:50%;font-size:6.1538461538rem;transform:translate(-50%, -50%)}", ""]);

// exports
